export enum LinkPositionEnum {
    BELOW_TEXT = 'belowText',
    OVER_IMAGE = 'overImage',
}
